let $selectRecipes;
let $selectArticles;
let $searchFilterContainer;

let $filterOpen;
let $filterClose;
let $filterReset;

$(document).ready(() => {
  $selectRecipes = $('.js-select-recipes');
  $selectArticles = $('.js-select-articles');

  $filterOpen = $('.js-filter-open');
  $filterClose = $('.js-filter-close');
  $filterReset = $('.js-filter-reset');

  $searchFilterContainer = $('.js-search-filter');

  // search-filter-disabled
  $selectRecipes.change(() => {
    updateSFCheckboxes();
  });
  $selectArticles.change(() => {
    updateSFCheckboxes();
  });

  $filterReset.on('click', () => {
    // Trigger reset name _sf_reset
    $('input[name="_sf_reset"]').trigger('click');
  });

  // convertTitlesToButton($filterTitles);
  // $('body').on('click', '.js-group-toggle', function () {
  //   $(this).next().slideToggle();
  //   $(this).toggleClass('is-open');
  // });

  $filterOpen.on('click', () => {
    $searchFilterContainer.addClass('is-open');
  });

  $filterClose.on('click', () => {
    $searchFilterContainer.removeClass('is-open');
  });

  // On sf start
  $(document).on('sf:ajaxstart', '.searchandfilter', () => {
    $searchFilterContainer.addClass('is-inactive');
  });

  // On sf start
  $(document).on('sf:ajaxfinish', '.searchandfilter', () => {
    $searchFilterContainer.removeClass('is-inactive');
  });

  const selectRecipesChecked = $('.js-select-recipes').prop('checked');

  if (selectRecipesChecked) {
    updateSFCheckboxes();
  }
});

// function convertTitlesToButton($titles) {
//   let index = 1;
//   $titles.each(function () {
//     const $title = $(this);
//     const $button = $('<button class="c-group-toggle js-group-toggle" type="button"></button>');
//
//     // Add class 'is-open' on first item in loop
//     if (index === 1) {
//       $button.addClass('is-open');
//     }
//
//     index++;
//     $button.text($title.text());
//     $title.replaceWith($button);
//   });
// }

function updateSFCheckboxes() {
  const selectRecipesChecked = $('.js-select-recipes').prop('checked');
  const selectArticlesChecked = $('.js-select-articles').prop('checked');

  const $checkboxes = $('input[name="_sf_post_type[]"]');

  // Als beide zijn aangevinkt of geen van beide, vink dan alle SF-checkboxes aan
  if (
    (selectRecipesChecked && selectArticlesChecked)
    || (!selectRecipesChecked && !selectArticlesChecked)
  ) {
    $('input[name="_sf_post_type[]"]').prop('checked', false);
  } else {
    if (selectRecipesChecked) {
      $('input[value="recept"]').prop('checked', true);
    }

    if (selectArticlesChecked) {
      $('input[name="_sf_post_type[]"]').not('input[value="recept"]').prop('checked', true);
    }
  }

  $checkboxes.trigger('change');
}
